import React, { useEffect, useState } from 'react';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { MasterMessage } from '../../../../masters/masterMessages';
import Swal from 'sweetalert2';
import ListView from '../../../components/views/listView';
import ModalLoading from '../../../components/general/loading/modalLoading';
import DropZoneField from '../../../components/general/fields/dropzoneField';
import Grid from '@mui/material/Grid';
import { SwalCustomClass } from '../../../components/general/toastSwal/swalCustomClass';
import {
    asyncGetTemplates,
    asyncPostLoadBaseGupshup,
} from '../../../../services/commercialCrm.service';
import AutocompleteField from '../../../components/general/fields/autoCompleteField';
import { CSVRender } from '../../../components/csvViewer/csvViewer';
import { requiredFields } from './fields';
import GupshupCsvHelpAccordion from './gupshupCsvHelpAccordion ';
import { Stack } from '@mui/material';

const LoadBaseGupshup = () => {
    const {
        titleListWhatsapp,
        messageError,
        titleModalLoadingWhatsapp,
        messageModalLoading,
    } = MasterMessage.commercialCrm.loadBase;
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState<any>([]);
    const [templates, setTemplates] = useState<any[]>();
    const [template, setTemplate] = useState<string>();
    const [showCsvViewer, setShowCsvViewer] = useState(false);

    const handleSave = () => {
        setShowCsvViewer(false);
        if (files.length > 0 && Boolean(template)) {
            setLoading(true);
            setTemplate(undefined);
            setFiles([]);
            asyncPostLoadBaseGupshup(files[0], template || '')
                .then((body: any) => {
                    if (body.items !== undefined) {
                        setLoading(false);
                        Swal.fire({
                            title: 'Carga Exitosa',
                            text: `Se cargaron ${body.items.total} registros exitosamente.`,
                            icon: 'success',
                            iconColor: '#1d1d1d',
                            confirmButtonColor: '#1d1d1d',
                            allowOutsideClick: false,
                            customClass: 'swal-wide-class',
                        });
                    } else {
                        Swal.fire({
                            title: 'Error Carga',
                            text: messageError,
                            icon: 'error',
                            iconColor: '#1d1d1d',
                            confirmButtonColor: '#1d1d1d',
                            customClass: 'swal-wide-class',
                        });
                    }
                })
                .finally(() => setLoading(false));
        } else {
            SwalCustomClass.fire({
                text: 'Debe seleccionar un archivo y una lista',
                icon: 'error',
                iconColor: '#1d1d1d',
            });
        }
    };

    useEffect(() => {
        (async () => {
            const { items } = await asyncGetTemplates();
            setTemplates(
                items.map((item) => ({ id: item.id, name: item.description }))
            );
        })();
    }, []);

    return (
        <>
            {loading ? (
                <ModalLoading
                    open
                    title={titleModalLoadingWhatsapp}
                    message={messageModalLoading}
                />
            ) : (
                <>
                    <Stack spacing={3}>
                        <GupshupCsvHelpAccordion />
                        <ListView
                            title={titleListWhatsapp}
                            titleButtonAdd={'Cargar'}
                            onClickAdd={() => setShowCsvViewer(true)}
                            startIconButtonAdd={
                                <FileUploadIcon color="secondary" />
                            }
                            disableBack
                            disableDataGrid
                            disabledAdd={!Boolean(template) || !files[0]}
                        />
                        <CSVRender
                            file={files[0]?.get('file')}
                            open={showCsvViewer}
                            onCloseCsvViewer={() => setShowCsvViewer(false)}
                            onAccept={handleSave}
                            requiredFields={requiredFields}
                        />
                        <Grid item xs={12} mt={3}>
                            <AutocompleteField
                                data={templates}
                                label="Selecciona una plantilla"
                                name="template"
                                size="small"
                                required
                                value={template}
                                onChangeValue={(value) => setTemplate(value)}
                            />
                        </Grid>
                        <Grid
                            container
                            spacing={{ xs: 1.5, md: 1.5 }}
                            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                        >
                            <Grid item xs={12} mt={3} sx={{ minWidth: 300 }}>
                                <DropZoneField
                                    name="File"
                                    maxFiles={1}
                                    accept=".csv"
                                    onChange={(value) => setFiles(value)}
                                />
                            </Grid>
                        </Grid>
                    </Stack>
                </>
            )}
        </>
    );
};

export default LoadBaseGupshup;
